import { Router } from "express";

import { deviceController } from "../controllers/device-controller";
import { notificationController } from "../controllers/notification-controller";
import { authenticate, createRateLimit } from "../middleware/auth-middleware";
import { requireRole } from "../middleware/role-middleware";

const router = Router();

// Environment-aware rate limiting
const generalRateLimit = createRateLimit.general();

/**
 * @route   GET /api/v1/notifications
 * @desc    Get all notifications for the authenticated user
 * @access  Private
 */
router.get("/", authenticate, generalRateLimit, (req, res) =>
  notificationController.getNotifications(req, res),
);

/**
 * @route   GET /api/v1/notifications/unread-count
 * @desc    Get unread notifications count
 * @access  Private
 */
router.get("/unread-count", authenticate, generalRateLimit, (req, res) =>
  notificationController.getUnreadCount(req, res),
);

/**
 * @route   PUT /api/v1/notifications/:id/read
 * @desc    Mark notification as read
 * @access  Private
 */
router.put("/:id/read", authenticate, generalRateLimit, (req, res) =>
  notificationController.markAsRead(req, res),
);

/**
 * @route   PUT /api/v1/notifications/read-all
 * @desc    Mark all notifications as read
 * @access  Private
 */
router.put("/read-all", authenticate, generalRateLimit, (req, res) =>
  notificationController.markAllAsRead(req, res),
);

router.post("/device-token", authenticate, generalRateLimit, (req, res) => {
  const { token, platform, deviceToken, deviceType, fcmToken } = req.body;
  req.body.deviceToken = deviceToken ?? token;
  req.body.deviceType = deviceType ?? platform;
  req.body.fcmToken = fcmToken ?? token;
  void deviceController.registerDevice(req, res);
});

router.delete("/device-token", authenticate, generalRateLimit, (req, res) => {
  const { token, deviceToken } = req.body;
  req.body.deviceToken = deviceToken ?? token;
  void deviceController.deactivateDevice(req, res);
});

/**
 * @route   DELETE /api/v1/notifications/:id
 * @desc    Delete a notification
 * @access  Private
 */
router.delete("/:id", authenticate, generalRateLimit, (req, res) =>
  notificationController.deleteNotification(req, res),
);

/**
 * @route   POST /api/v1/notifications
 * @desc    Create a notification (Admin only)
 * @access  Private (Admin)
 */
router.post(
  "/",
  authenticate,
  requireRole(["admin"]),
  generalRateLimit,
  (req, res) => notificationController.createNotification(req, res),
);

/**
 * Student Notification Routes
 */

/**
 * @route   GET /api/v1/student/notifications
 * @desc    Get all notifications for student
 * @access  Private (Student)
 */
router.get(
  "/student/notifications",
  authenticate,
  requireRole(["student"]),
  generalRateLimit,
  (req, res) => notificationController.getStudentNotifications(req, res),
);

/**
 * Teacher Notification Routes
 */

/**
 * @route   GET /api/v1/teacher/notifications
 * @desc    Get all notifications for teacher
 * @access  Private (Teacher)
 */
router.get(
  "/teacher/notifications",
  authenticate,
  requireRole(["teacher"]),
  generalRateLimit,
  (req, res) => notificationController.getTeacherNotifications(req, res),
);

/**
 * School Notification Routes
 */

/**
 * @route   GET /api/v1/school/notifications
 * @desc    Get all notifications for school admin
 * @access  Private (School Admin)
 */
router.get(
  "/school/notifications",
  authenticate,
  requireRole(["school"]),
  generalRateLimit,
  (req, res) => notificationController.getSchoolNotifications(req, res),
);

/**
 * Admin Notification Routes
 */

/**
 * @route   GET /api/v1/admin/notifications
 * @desc    Get all notifications for admin
 * @access  Private (Admin)
 */
router.get(
  "/admin/notifications",
  authenticate,
  requireRole(["admin"]),
  generalRateLimit,
  (req, res) => notificationController.getAdminNotifications(req, res),
);

export default router;
